function titleCase(text) {
    return String(text || '')
        .toLowerCase()
        .replace(/(^|[\s'-])(\p{L})/gu, (match, lead, letter) => lead + letter.toUpperCase())
}

// Registry search results as autocomplete items, one per NPI. A referrer searches by name, never by NPI.
export function registryProvidersToItems(response) {
    const providers = Array.isArray(response) ? response : response?.data || []
    const seen = new Set()

    return providers.reduce((items, provider) => {
        const npi = String(provider?.npi || '')
        if (!/^\d{10}$/.test(npi) || seen.has(npi)) return items
        seen.add(npi)

        const firstName = titleCase(provider.firstName || provider.user?.firstName)
        const lastName = titleCase(provider.lastName || provider.user?.lastName)
        const place = [titleCase(provider.city), provider.state].filter(Boolean).join(', ')

        items.push({
            isRegistryProvider: true,
            isPhysician: true,
            npi,
            firstName,
            lastName,
            name: [firstName, lastName].filter(Boolean).join(' '),
            designation: provider.user?.credential || '',
            specialization: provider.specialization || '',
            primarySpeciality: [provider.specialization || provider.primarySpecialty, place]
                .filter(Boolean)
                .join(' · '),
        })
        return items
    }, [])
}
